import { createFileRoute } from "@tanstack/react-router";
import { AnalyticsPage } from "@/pages/AnalyticsPage";

// Internt analytics-dashboard. Bevidst udenfor pageHead()/sitemap-flowet:
// noindex + ingen canonical/hreflang, og robots.txt disallow'er stien.
export const Route = createFileRoute("/analytics")({
  head: () => ({
    meta: [{ title: "Analytics - MI Support" }, { name: "robots", content: "noindex, nofollow" }],
  }),
  component: AnalyticsPage,
});
